var map = {
	"./2022-05-13T05-58-08.932Z_Redragon ARYAMAN .jpg": 3903,
	"./addToCart.svg": 7199,
	"./arrow.svg": 8813,
	"./asus.png": 7393,
	"./basket.svg": 2964,
	"./basketHeader.svg": 3180,
	"./cable.png": 8009,
	"./cake.png": 6656,
	"./case.png": 5532,
	"./catalog.svg": 8533,
	"./chair.png": 5254,
	"./clock.png": 3653,
	"./closeBtn.svg": 8663,
	"./comments.png": 3772,
	"./compair.svg": 2234,
	"./computer-hardware.png": 6162,
	"./cooler (1).png": 5618,
	"./cooler.png": 9176,
	"./correct-icon.svg": 1730,
	"./delete.svg": 1673,
	"./desktop.png": 627,
	"./dvr.png": 9740,
	"./eldor.jpg": 8032,
	"./extensioncable.png": 5971,
	"./eye.svg": 6461,
	"./facebook.svg": 3536,
	"./footer-logo.svg": 5007,
	"./game.png": 1192,
	"./gamepad.png": 5633,
	"./graphics-card.png": 4671,
	"./headphones.png": 5731,
	"./heart.svg": 7730,
	"./high-tower.png": 4798,
	"./instagram.svg": 5397,
	"./keyboard-and-mouse.png": 6680,
	"./keyboard.png": 3168,
	"./keyboard1.png": 1715,
	"./laptop(transformer).png": 3080,
	"./laptop-screen.png": 1320,
	"./location.png": 4752,
	"./location.svg": 3968,
	"./lock.svg": 3006,
	"./logo.png": 4427,
	"./logo.svg": 2835,
	"./logoBlueBackground.svg": 2138,
	"./loud-speaker.png": 233,
	"./mail.png": 3655,
	"./map.png": 6234,
	"./motherboard.png": 2858,
	"./news-1.png": 8397,
	"./payment.png": 8447,
	"./payment.svg": 5144,
	"./percent.png": 1915,
	"./power-supply.png": 1391,
	"./printer.png": 9350,
	"./profile-img.svg": 3213,
	"./ram-memory.png": 1003,
	"./rassrochka1.png": 253,
	"./rassrochka2.png": 6230,
	"./rug.png": 7603,
	"./search.svg": 3794,
	"./security-camera.png": 3061,
	"./service.png": 6491,
	"./shipping.png": 4750,
	"./shipping.svg": 7272,
	"./sigviy1.png": 5698,
	"./sigviy2.png": 4823,
	"./slider-1.jpg": 5655,
	"./slider-2.jpg": 3623,
	"./slider-3.jpg": 3760,
	"./smart-watch.png": 2441,
	"./ssd-drive (1).png": 6039,
	"./ssd-drive.png": 6420,
	"./ssd-product.jpg": 555,
	"./ssd.png": 3513,
	"./stabilizer.png": 7736,
	"./star(white).svg": 4043,
	"./star.svg": 3111,
	"./supply.png": 3742,
	"./telegram.svg": 351,
	"./triangle.svg": 4580,
	"./ups.png": 937,
	"./usb.png": 2063,
	"./userPhoto.jpg": 1920,
	"./webcam.png": 4371,
	"./wifi.png": 1861,
	"./wireless-mouse.png": 2808,
	"./youtube.svg": 3672
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 990;